import React, { useState } from 'react';
import { makeStyles, createStyles, Theme, Button, Hidden, useTheme, useMediaQuery, Paper, Grid, CircularProgress } from '@material-ui/core';
import { FaCheck, FaSave } from 'react-icons/fa';
import EditHeader from './EditHeader';
import CustomScrollbar from 'react-scrollbars-custom';
import { MdCancel } from 'react-icons/md';
import { useHistory } from 'react-router';

interface ComponentProps {
  title?: string;
  showButtons: boolean;
  onBackIconClick?: React.MouseEventHandler<HTMLElement>;
  onAcceptClick?: () => Promise<void>;
  onCancelClick?: React.MouseEventHandler<HTMLElement>;
  hideHeader?: boolean;
  acceptButtonText?: string;
  acceptButtonIcon?: React.ReactNode;
  acceptButtonDisabled?: boolean;
  acceptButtonBackgroundColor?: string;
  acceptButtonForegroundColor?: string;
  cancelButtonText?: string;
  cancelButtonIcon?: React.ReactNode;
  formId?: string;
  formIsSubmitting?: boolean;
  moreActionsButton?: React.ReactNode;
}

const EditLayout: React.FC<ComponentProps> = React.memo((props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const history = useHistory();
  const { moreActionsButton } = props;

  return (
    <div className={classes.root}>
      {!props.hideHeader &&
        <div>
          <div className={classes.appBarSpacer}></div>
          <EditHeader title={props.title} handleIconClick={props.onBackIconClick} />
        </div>
      }
      {!props.showButtons ? null : matchesXS
        ?
        <div>
          {props.children}
          <div style={{ height: 80 }} />
        </div>
        :
        <div className={classes.mainContainer}>
          <Paper elevation={2} className={classes.paper}>
            <Grid container direction="column" justify="flex-start" style={{ height: '100%' }}>
              <Grid item style={{
                flexGrow: 1,
              }}>
                <CustomScrollbar >
                  {props.children}
                </CustomScrollbar>
              </Grid>
              <Grid item style={{
              }}>
                <Hidden xsDown>
                  <Grid container direction="row" justify="flex-end" alignItems="center"
                    style={{ padding: 8 }}
                  >
                    {
                      typeof moreActionsButton !== 'undefined' ? moreActionsButton : undefined
                    }
                    <Grid item >
                      <LoadingButton
                        type="submit"
                        form={props.formId}
                        variant="contained"
                        color="primary"
                        style={{
                          backgroundColor:
                            !!props.acceptButtonDisabled || props.formIsSubmitting
                              ? '#666'
                              : props.acceptButtonBackgroundColor
                                ? props.acceptButtonBackgroundColor
                                : undefined,
                          color: props.acceptButtonForegroundColor ? props.acceptButtonForegroundColor : undefined,
                          marginLeft: 16
                        }}
                        disabled={!!props.acceptButtonDisabled}
                        icon={
                          props.formIsSubmitting
                            ? <CircularProgress color="secondary" size={24} />
                            : props.acceptButtonIcon
                              ? props.acceptButtonIcon : <FaSave />
                        }
                        onClick={props.onAcceptClick}
                        text={props.acceptButtonText ? props.acceptButtonText : 'Guardar'}
                      />
                      <Button
                        variant="outlined"
                        className={classes.button}
                        style={{ marginRight: 0 }}
                        startIcon={props.cancelButtonIcon ? props.cancelButtonIcon : <MdCancel />}
                        onClick={(event) => { props.onCancelClick ? props.onCancelClick(event) : history.goBack() }}
                      >
                        {props.cancelButtonText ? props.cancelButtonText : 'Cancelar'}
                      </Button>
                    </Grid>
                  </Grid>
                </Hidden>
              </Grid>
            </Grid>
          </Paper>
        </div>
      }
      {
        props.showButtons &&
        <Hidden smUp>
          <footer className={classes.footer}>
            {/* <Button
              type="submit"
              form={props.formId}
              fullWidth
              variant="contained"
              color="primary"
              style={{
                backgroundColor:
                  props.acceptButtonDisabled
                    ? '#666'
                    : props.acceptButtonBackgroundColor
                      ? props.acceptButtonBackgroundColor
                      : undefined,
                color: props.acceptButtonForegroundColor ? props.acceptButtonForegroundColor : undefined
              }}
              disabled={!!props.acceptButtonDisabled}
              // startIcon={props.acceptButtonIcon ? props.acceptButtonIcon : <FaCheck />}
              startIcon={<CircularProgress color="secondary" size={24} />}
              onClick={props.onAcceptClick}
            >
              {props.acceptButtonText ? props.acceptButtonText : 'Aplicar Cambios'}
            </Button> */}
            <LoadingButton
              type="submit"
              form={props.formId}
              fullWidth
              variant="contained"
              color="primary"
              style={{
                backgroundColor:
                  props.acceptButtonDisabled || props.formIsSubmitting
                    ? '#666'
                    : props.acceptButtonBackgroundColor
                      ? props.acceptButtonBackgroundColor
                      : undefined,
                color: props.acceptButtonForegroundColor ? props.acceptButtonForegroundColor : undefined
              }}
              disabled={!!props.acceptButtonDisabled}
              icon={
                props.formIsSubmitting
                  ? <CircularProgress color="secondary" size={24} />
                  : props.acceptButtonIcon
                    ? props.acceptButtonIcon : <FaCheck />
              }
              onClick={props.onAcceptClick}
              text={props.acceptButtonText ? props.acceptButtonText : 'Aplicar Cambios'}
            />
          </footer>
        </Hidden>
      }
    </div >);
});

const LoadingButton = ({ onClick, text, icon, disabled, ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Button
      {...rest}
      startIcon={isLoading ? <CircularProgress color="secondary" size={24} /> : icon}
      onClick={async () => {
        setIsLoading(true);
        await onClick();
        setIsLoading(false);
      }}
      disabled={isLoading || disabled}
    >
      {text}
    </Button>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
    },
    appBarSpacer: {
      ...theme.mixins.toolbar,
      minHeight: 64,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        marginBottom: theme.spacing(2),
      },
    },
    button: {
      marginLeft: theme.spacing(2),
    },
    buttonsContainer: {
      position: 'fixed',
      zIndex: 1,
      bottom: 0,
      paddingRight: theme.spacing(5),
      paddingBottom: theme.spacing(4),
      backgroundColor: 'transparent',
    },
    footer: {
      position: 'fixed',
      opacity: 1,
      bottom: 0,
      zIndex: 1,
      width: '100%',
      padding: theme.spacing(2),
      backgroundColor: '#fff',
      textAlign: 'center'
    },
    mainContainer: {
      width: '100vw',
      height: `calc(100vh - 64px - ${theme.spacing(4)}px )`,//viewport - appbar - padding 
    },
    paper: {
      padding: 16,
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      height: '100%'
    }
  }),
);

export default EditLayout;
